import { NewsletterListSearchCriteria } from '../models/newsletter.model';

export class NewsletterListLoad {
  public static readonly type = '[NewsletterList] Load';
  constructor(public payload: NewsletterListSearchCriteria) {}
}

export class NewsletterListInitialState {
  public static readonly type = '[NewsletterList] Set initial state';
}
